import { createSelector } from "reselect";

const getSurgeryStore = (state) => state.surgery;

export const getInfoInterventoStore = createSelector(getSurgeryStore, (surgery) => surgery.infoIntervento);

export const getInfoIntervento = createSelector(getInfoInterventoStore, (infoIntervento) => infoIntervento.data);
export const fetchInfoInterventoEnded = createSelector(getInfoInterventoStore, (infoIntervento) => infoIntervento.fetchEnded); //prettier-ignore
export const getLastUpdateInfo = createSelector(getInfoInterventoStore, (infoIntervento) => infoIntervento.lastUpdate);
export const getCallNumber = createSelector(getInfoInterventoStore, (infoIntervento) => infoIntervento.callNumber);

export const getInfoStruttura = createSelector(getSurgeryStore, (surgery) => surgery.infoStruttura);

export const getRicercaEffettuata = createSelector(getSurgeryStore, (surgery) => surgery.ricercaEffettuata);
